import React from 'react';



const formatNumber = x => Number(x).toLocaleString();
const productions = [
    {
      range: `< ${formatNumber(1000)}`
    },
    {
      range: `${formatNumber(1000)} - ${formatNumber(4999)}`
    },
    {
      range: `${formatNumber(5000)} - ${formatNumber(49999)}`
    },
    {
      range: `${formatNumber(50000)} - ${formatNumber(499999)}`
    },
    {
      range: `> ${formatNumber(500000)}`
    },
]

function SortByAnnualProduction({
  selectedProductionRange,
  setSelectedProductionRnage
}) {

  // for sorting
  // const handleOnChange = (e) => {
  //   if(e.target.checked){
  //     setSelectedProductionRnage(e.target.name)
  //   } else {
  //     setSelectedProductionRnage(null)
  //   }
  // }

  // for filtering
  const handleOnChange = (e) => {
    if(e.target.checked){
      setSelectedProductionRnage([...selectedProductionRange, e.target.name])
    } else {
      setSelectedProductionRnage([...selectedProductionRange].filter(x => x !== e.target.name))
    }
  }

  return (
    <div>
      <h3>Annual Production</h3>
      {productions.map((p, index) => (
        <div key={index} style={{display: 'flex', alignItems: 'center'}}>
          <input
            id={p.range}
            name={p.range}
            onChange={handleOnChange}
            checked={selectedProductionRange?.includes(p.range)}
            type="checkbox"
            style={{display: 'inline-block', width: 'auto', marginRight: "10px"}}
          />
          <label htmlFor="">{p.range}</label>
        </div>
      ))}
    </div>
  )
}

export default SortByAnnualProduction
